import { render, staticRenderFns } from "./accountStep6.vue?vue&type=template&id=2e99c3b0&"
import script from "./accountStep6.vue?vue&type=script&lang=js&"
export * from "./accountStep6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports